import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { ArrowRight2Icon } from '@blade/ui-kit'
import { openDownloadDialogAction } from '@root/entities/deeplinking'
import { isTauriOrBrowserLocalAtom } from '@root/shared'

import { PaymentDialogWallet } from './payment-dialog-wallet'

import type { PaymentSourceWallet } from '../atoms'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  disabled?: boolean
  errorMessage?: string
  paymentSource?: PaymentSourceWallet
  setWalletDialogOpen: (open: boolean) => void
} & ClassNameProps

export const PaymentWalletsInput: React.FC<Props> = ({
  paymentSource,
  disabled,
  errorMessage,
  setWalletDialogOpen,
}) => {
  const openDownloadDialog = useAction(openDownloadDialogAction)
  const [isTauri] = useAtom(isTauriOrBrowserLocalAtom)

  const handleSelectWallet = () => {
    if (disabled) {
      return
    }
    if (isTauri) {
      setWalletDialogOpen(true)
    } else {
      openDownloadDialog()
    }
  }

  return (
    <Root
      data-error={!!errorMessage}
      type="button"
      onClick={handleSelectWallet}
    >
      <InputWrapper>
        <PaymentDialogWallet wallet={paymentSource?.wallet} />
      </InputWrapper>
      <Arrow>
        <ArrowRight2Icon size={12} />
      </Arrow>
    </Root>
  )
}

const Root = styled.button`
  height: var(--payment-wallets-input-height, 40px);
  color: var(--text-11);
  background: var(--appearance-1);

  cursor: pointer;
  width: 100%;
  border-radius: 10px;
  padding: 2px;

  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
  gap: 10px;

  border: var(--input-border, 1px solid transparent);

  transition: all 0.3s ease;

  &[data-error='true'] {
    border: 1px solid var(--errorA-6);
  }

  [data-disabled='true'] & {
    cursor: default;
  }

  &:hover {
    border: var(--input-border-active, 1px solid var(--backgroundA-5));
    color: var(--text-12);

    &[data-error='true'] {
      border: 1px solid var(--errorA-6);
    }
  }
`

const InputWrapper = styled.div`
  [data-disabled='true'] & {
    opacity: 0.3;
  }
`

const Arrow = styled.span`
  background: var(--backgroundA-3);

  border-radius: 8px;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  width: 24px;

  [data-disabled='true'] & {
    opacity: 0.7;
  }
`
